import { NgModule } from '@angular/core';
import { Title } from '@angular/platform-browser';

import {
    QueuingSystemSharedLibsModule,
    LanguageHelper,
    FindLanguageFromKeyPipe,
} from './';

@NgModule({
    imports: [
        QueuingSystemSharedLibsModule
    ],
    declarations: [
        FindLanguageFromKeyPipe
    ],
    providers: [
        LanguageHelper,
        Title
    ],
    exports: [
        QueuingSystemSharedLibsModule,
        FindLanguageFromKeyPipe
    ]
})
export class QueuingSystemSharedCommonModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/shared-common.module.ts